import { Dispatch, makeActionCreator, RootState } from "../../store/types";
import {
  Product,
  ProductCostPolicy,
  DeliverableChargePolicy as DChargePolicy,
  DeliverableTimePolicy as DTimePolicy,
} from "../../models";
import { selectors as step1Selectors } from "../Step1";

export const TOGGLE_TOC = "summary/TOGGLE_TOC_AGREEMENT";
export const SET_DATA_LOADING = "summary/SET_DATA_LOADING";
export const SET_CHARGE_POLICIES = "summary/SET_CHARGE_POLICIES";
export const SET_TIME_POLICIES = "summary/SET_TIME_POLICIES";
export const SET_COST_POLICY = "summary/SET_COST_POLICY";
export const RESET = "summary/RESET";

export const toggleTOCAgreement = makeActionCreator(
  TOGGLE_TOC as typeof TOGGLE_TOC,
);
const setChargePolicies = makeActionCreator<
  DChargePolicy[]
>(SET_CHARGE_POLICIES as typeof SET_CHARGE_POLICIES);
const setTimePolicies = makeActionCreator<
  DTimePolicy[]
>(SET_TIME_POLICIES as typeof SET_TIME_POLICIES);
const setCostPolicy = makeActionCreator<
  ProductCostPolicy
>(SET_COST_POLICY as typeof SET_COST_POLICY);
const setDataLoading = makeActionCreator<
  boolean
>(SET_DATA_LOADING as typeof SET_DATA_LOADING);
export const reset = makeActionCreator(RESET as typeof RESET);

// Thunks
export const fetchEstimateData = () => async (
  dispatch: Dispatch,
  getState: () => RootState,
  http,
) => {
  dispatch(setDataLoading(true));

  try {
    const product = step1Selectors.chosenProduct(getState()) as Product;

    const response: any = await http.get(
      `data/products/${product.id}/estimations`,
    );

    dispatch(setCostPolicy(response.costPolicy));
    dispatch(setChargePolicies(response.deliverableChargePolicies || []));
    dispatch(setTimePolicies(response.deliverableTimePolicies || []));
  } catch (error) {
    throw error;
  } finally {
    dispatch(setDataLoading(false));
  }
};



// WEBPACK FOOTER //
// ./src/routes/WizardSummary/actions.ts